/* eslint-disable max-classes-per-file */
import React from 'react';
import * as yup from 'yup';
import { createBrowserHistory } from 'history';
// eslint-disable-next-line no-duplicate-imports
import { Schema } from 'yup';


export class FormField<
    FieldType extends string | number | Date | boolean | null | undefined
> {
    constructor(
        name: string,
        setter: React.Dispatch<FieldType>,
        schema: Schema<FieldType>,
        value: FieldType
    ) {
        this.name = name;
        this.setter = setter;
        this.schema = schema;
        this.value = value;
    }

    public valid = false;

    public name: string;

    public value: FieldType;

    public setter: React.Dispatch<FieldType>;

    public schema?: Schema<FieldType>;
}

export class FormModel {

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        [x: string]: any;
        
    constructor(validSetter: React.Dispatch<boolean>) {
        this.validSetter = validSetter;

        const [, updateState] = React.useState();
        this.RefreshForm = React.useCallback(() => updateState({}), []);
    }

    private RefreshForm: () => void;

    private validSetter: React.Dispatch<boolean>;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private fields: FormField<any>[] = [];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private validationSchema: yup.ObjectSchema<object & any[]>|undefined;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private valuesHash: any = {};

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public errors: any = {};

    public valid = false;

    public Reset = () => {
        this.fields = [];
        this.errors = {};
    };
   
    private async Build() {    
        // eslint-disable-next-line @typescript-eslint/no-explicit-any    
        const fieldsSchema: any = {};
        this.fields.forEach(f=> {
            fieldsSchema[f.name] = f.schema;
        });

        this.validationSchema = yup.object().shape(fieldsSchema);
    }

    public async Validate(fieldName?: string) { 
        let valid = false;

        // all form will be validated then reset validation
        this.ClearErrors(fieldName);

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const formValues: any = this.getFormValues();

        if (!this.validationSchema) this.Build();
        
        await this.validationSchema?.validate(formValues, {abortEarly: false})       
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .then((r) => {
            valid = true;
         })
         .catch((errors) => {
            valid = false;
            const {inner:validationErrors} = errors;

            // eslint-disable-next-line no-unused-expressions
            validationErrors?.forEach((
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                error: any) => {
                const field = this.getField(error.params.path);
                field.valid = false;
                if (
                    // case of validate all forms so show all errors
                    !fieldName || 
                    // case of validate single field so show error of it only
                    field.name === fieldName || 
                    // case of update error in case of language changed
                    (this.errors[field.name] && this.errors[field.name] !== error.message) 
                    ) this.errors[field.name] = error.message;
            });
            
         });

        this.RefreshForm();
        this.validSetter(valid);
        this.valid = valid;
        return valid;
    }

    public async UpdateField<FieldType extends string | number | Date | boolean | null | undefined>(
        name?: string, value?: FieldType | undefined) {

        // update current field value
        if(name){
            const currentField = this.getField(name);
            currentField.value = value;
            currentField.setter(value);
        }

        this.Validate(name);
    } 

    private getFormValues(){
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const formValues: any = {};
        this.fields.forEach(field=> {
            formValues[field.name] = field.value === null? undefined : field.value;
        });
        return formValues;
    }

    
    public AddField<
        FieldType extends string | number | Date | boolean | null | undefined
    >(
        name: string,
        setter: React.Dispatch<FieldType>,
        schema: Schema<FieldType>,
        value: FieldType
    ) {
        const existingFieldIndex = this.getFieldIndex(name);
        if (existingFieldIndex >= 0){
            this.validationSchema = undefined;
            this.fields.splice(existingFieldIndex, 1);
        }

        const newField = new FormField(name, setter, schema, value);
        this.fields.push(newField);        
    }

    public ClearErrors = (fieldName?: string) => {
        if (!fieldName) this.errors = {};

        this.fields.forEach(field=> {
            // eslint-disable-next-line no-param-reassign
            field.valid = true;
            if (fieldName && field.name === fieldName) this.errors[field.name] = '';
        });

        this.RefreshForm();
    };

    public async UpdateFieldWithError<
        FieldType extends string | number | Date | boolean | null | undefined
    >(name: string, error: string) {
        const field = this.getField(name);
        this.errors[name] = error;
        this.RefreshForm();
        return field.valid;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public AddValue<ValueType extends any>(name: string, value: ValueType) {
        this.valuesHash[name] = value;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public GetValue<ValueType extends any>(name: string): ValueType {
      
        const value = this.valuesHash[name] as ValueType;
        return value;
    }

    // eslint-disable-next-line class-methods-use-this
    public RedirectTo(
        route: string, 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        state: any) {
        const history = createBrowserHistory();
        history.push({ pathname: route, state, search: '', hash: '' });
        history.go(0);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public getField(name: string): FormField<any> {
        const field = this.fields.find((f) => f.name === name);

        if (!field) throw new Error(`FormModel: Couldn't find field '${name}'`);

        return field;
    }

    public getFieldIndex(name: string): number {
        const field = this.fields.find((f) => f.name === name);
        if (field) {
            const fieldIndex = this.fields.indexOf(field);
            return fieldIndex;
        }
        return -1;
    }
}
